import script from "./FlashMessengerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlashMessengerComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FlashMessengerComponent.vue?vue&type=style&index=0&id=4f8805b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8805b0"]])

export default __exports__